import styled, { css } from 'styled-components'
import { remCalculator } from '../../../helpers/theming/utilities'

const StyledContainer = styled.div`
  ${(props) =>
    props.numberOfQuotes &&
    css`
      margin-bottom: ${remCalculator(props.theme.size.spacing.xl)};
    `}

  min-width:100%;
`
// Below styles should be removed when DS grid migration is done
const xsRowStyles = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
`

const StyledWrapper = styled.div`
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      ${xsRowStyles}
      margin-left: 15px;
      margin-right: 15px;
      flex: 0 0 auto;
      flex-basis: calc(100% - 30px);
      max-width: calc(100% - 30px);
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        flex-basis: calc(50% - 30px);
        max-width: calc(50% - 30px);
      }
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
        flex-basis: calc(33.3333333333% - 30px);
        max-width: calc(33.3333333333% - 30px);
      }
    `}
`
const StyledModalContainer = styled.div`
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      ${xsRowStyles}
      margin-left: -15px;
      margin-right: -15px;
      flex: 0 0 auto;
      flex-basis: calc(100% + 30px);
      max-width: calc(100% + 30px);
    `}
`
// Above styles should be removed when DS grid migration is done

export { StyledContainer, StyledWrapper, StyledModalContainer }
